module.exports = __webpack_public_path__ + "img/home-compac_reducida2.cd609849.png";